import { trackMixpanelEvent } from '@libs/mixpanel/mixpanel';

const KEY = 'demoAnalyticsSession';
type DemoSession = { id: string; tracked: string[]; emailRequired: boolean };
let session: DemoSession | undefined;

function storedEmail() {
  try {
    return localStorage.getItem('demoUserEmail');
  } catch {
    return null;
  }
}

function getSession(): DemoSession {
  if (session) return session;
  try {
    const saved = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    if (
      saved &&
      typeof saved.id === 'string' &&
      Array.isArray(saved.tracked) &&
      typeof saved.emailRequired === 'boolean'
    )
      session = saved;
  } catch {
    /* Continue tracking within this page when storage is unavailable. */
  }
  session ??= { id: crypto.randomUUID(), tracked: [], emailRequired: !storedEmail() };
  return session;
}

function trackStep(name: string, properties: Record<string, string | boolean> = {}) {
  const current = getSession();
  if (current.tracked.includes(name)) return;
  try {
    const accepted = trackMixpanelEvent(name, {
      ...properties,
      is_demo: true,
      demo_session_id: current.id,
      $insert_id: `${current.id}:${name}`,
      email_required: current.emailRequired,
    });
    if (!accepted) return;
  } catch {
    return;
  }
  current.tracked.push(name);
  try {
    sessionStorage.setItem(KEY, JSON.stringify(current));
  } catch {
    /* In-memory deduplication remains. */
  }
}

export function trackDemoRequested() {
  trackStep('demo_requested', { source: 'demo_url' });
}

export function trackDemoEmailSubmitted(email: string) {
  trackDemoRequested();
  trackStep('demo_email_submitted', { email });
}

export function trackDemoStarted() {
  trackDemoRequested();
  const email = storedEmail();
  if (email) trackStep('demo_started', { email });
}
